import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/delivery/sites/")({
  head: () => ({
    meta: [{ title: "网站列表 · imiker CRM" }],
  })
});
